module.exports = __webpack_public_path__ + "images/arrow-slider.png?v=3b9ea9e7084240da59cddd55a46bdaab";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-slider.png
// module id = 618
// module chunks = 0